import { Link } from "@inertiajs/react"
import { Heart, House, ReceiptText } from "lucide-react"
import { Button } from "@/components/ui/button"
import { DINER_HOME_PATH } from "@/lib/diner-home"
import { t } from "@/lib/i18n"

type FarewellScreenProps = {
  locationName: string | null
  tableName: string | null
  billId: number | null
}

export function FarewellScreen({ locationName, tableName, billId }: FarewellScreenProps) {
  return (
    <div
      className="mx-auto flex w-full max-w-md flex-col items-center px-4 pb-8 pt-14 text-center text-foreground"
      data-testid="farewell-screen-view"
    >
      <span className="mb-4 inline-flex size-16 items-center justify-center rounded-full bg-brand/12 text-brand">
        <Heart className="size-8" />
      </span>

      <h1 className="text-2xl font-semibold tracking-tight">
        {t("ui.react.features.user.farewell_screen.thanks_for_visit")}
      </h1>

      <p className="mt-2 text-sm text-muted-foreground">
        {locationName
          ? t("ui.react.features.user.farewell_screen.bill_closed_at", { name: locationName })
          : t("ui.react.features.user.farewell_screen.bill_closed_generic")}
      </p>

      {tableName && (
        <p className="mt-1 text-sm text-muted-foreground">
          {t("ui.react.features.user.farewell_screen.table_closed", { name: tableName })}
        </p>
      )}

      <div className="mt-8 flex w-full flex-col gap-2.5">
        <Button asChild size="lg" className="w-full" data-testid="farewell-home-button">
          <Link href={DINER_HOME_PATH}>
            <House />
            {t("ui.react.features.user.farewell_screen.go_home")}
          </Link>
        </Button>

        {billId && (
          <Button
            asChild
            size="lg"
            variant="outline"
            className="w-full"
            data-testid="farewell-bill-button"
          >
            <Link href={`/bills/${billId}/receipt`}>
              <ReceiptText />
              {t("ui.react.features.user.farewell_screen.view_bill")}
            </Link>
          </Button>
        )}
      </div>
    </div>
  )
}
